import React, { useEffect, useRef, useState } from "react";
import "./homeSection.css";

const InsigniaProduct = ({ image, title, description, buttonText, buttonLink }) => {
    const [isVisible, setIsVisible] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true); // Activa la animación cuando el elemento entra en pantalla
                } else {
                    setIsVisible(false); // Opcional: para reiniciar la animación
                }
            },
            { threshold: 0.1 } // Activa cuando el 10% del componente es visible
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);

    return (
        <div
            ref={containerRef}
            className={`home-section home-section--blue ${isVisible ? "visible" : ""}`}
        >
            <div className="home-section__container">
                <div className="home-section__frame image-side">
                    <img src={image} alt="insignia-product" />
                </div>

                <div className="home-section__text text-side">
                    <h2 className="home-section__heading">{title}</h2>
                    <p className="home-section__description">{description}</p>
                    <a href={buttonLink} className="home-section__cta">
                        {buttonText}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default InsigniaProduct;
